const delayedInvalidationsByClient = new WeakMap();

const stableKey = (queryKey) => JSON.stringify(queryKey || []);

export const billingRetryAfterMs = (error, fallbackMs = 30_000) => {
  const bodySeconds = Number(error?.response?.data?.retryAfterSeconds ?? error?.response?.data?.retry_after_seconds);
  if (Number.isFinite(bodySeconds) && bodySeconds > 0) return bodySeconds * 1000;
  const raw = error?.response?.headers?.['retry-after'] || error?.response?.headers?.['Retry-After'];
  const seconds = Number(raw);
  if (Number.isFinite(seconds) && seconds > 0) return seconds * 1000;
  const dateMs = Date.parse(raw);
  if (Number.isFinite(dateMs)) return Math.max(0, dateMs - Date.now());
  return fallbackMs;
};

export const scheduleBillingQueryInvalidation = (
  queryClient,
  { queryKey, delayMs = 20_000, refetchType = 'inactive' } = {},
) => {
  if (!queryClient || !queryKey) return;
  let clientTimers = delayedInvalidationsByClient.get(queryClient);
  if (!clientTimers) {
    clientTimers = new Map();
    delayedInvalidationsByClient.set(queryClient, clientTimers);
  }
  const key = `${stableKey(queryKey)}:${refetchType}`;
  if (clientTimers.has(key)) clearTimeout(clientTimers.get(key));
  const timer = setTimeout(() => {
    clientTimers.delete(key);
    queryClient.invalidateQueries({ queryKey, refetchType });
  }, delayMs);
  clientTimers.set(key, timer);
};

export const scheduleBillingQueryInvalidations = (queryClient, specs = [], options = {}) => {
  specs.forEach((spec) => {
    if (!spec) return;
    scheduleBillingQueryInvalidation(queryClient, Array.isArray(spec) ? { ...options, queryKey: spec } : { ...options, ...spec });
  });
};

export const invalidateBillingBacContext = (queryClient, { runId = null } = {}) => {
  if (!queryClient) return;
  if (runId) {
    queryClient.invalidateQueries({ queryKey: ['billingRecon', 'bacContext', runId] });
    queryClient.invalidateQueries({ queryKey: ['billingRecon', 'operatorContext', runId] });
    return;
  }
  queryClient.invalidateQueries({ queryKey: ['billingRecon', 'bacContext'] });
  queryClient.invalidateQueries({ queryKey: ['billingRecon', 'operatorContext'] });
};

export const invalidateBillingVarianceLists = (queryClient, { runId = null } = {}) => {
  if (!queryClient) return;
  if (runId) {
    queryClient.invalidateQueries({ queryKey: ['billingRecon', 'variancesAll', runId] });
    queryClient.invalidateQueries({ queryKey: ['billingRecon', 'variances', runId] });
    return;
  }
  queryClient.invalidateQueries({ queryKey: ['billingRecon', 'variancesAll'] });
  queryClient.invalidateQueries({ queryKey: ['billingRecon', 'variances'] });
};

export const invalidateBillingWarmContextDependents = (queryClient, { runId = null } = {}) => {
  invalidateBillingBacContext(queryClient, { runId });
  invalidateBillingVarianceLists(queryClient, { runId });
};
